'use strict';
const { createAddQueries } = require('../addQueries');
const { id, createFilterConfig } = require('./commons');

module.exports = createAddQueries({
  returnModel: {
    name: 'insightevents',
  },
  finders: [
    id,
    createFilterConfig('eventName', 'eventname', 'string'),
    createFilterConfig('insightEventIdStr', 'insighteventidstr', 'string'),
  ],
  orderBy: [
    id,
    createFilterConfig('eventName', 'eventname', 'string'),
    createFilterConfig('insightEventIdStr', 'insighteventidstr', 'string'),
  ],
});
